import React from "react"
import { MyPageHelpers } from "@macashipo/mlib"

const PageCreateTask = React.lazy(() => import("./Types/PageCreateTask"))
const PageMyTasks = React.lazy(() => import("./Types/PageMyTasks"))
const PageTable = React.lazy(() => import("./Types/PageTable"))
const PageSearchEditTask = React.lazy(
  () => import("./Types/PageSearchEditTask")
)
const PageDashboard = React.lazy(() => import("./Types/PageDashboard"))
const PageTaskDetail = React.lazy(() => import("./Types/PageTaskDetail"))
const PageListTask = React.lazy(() => import("./Types/PageListTask"))
const PageMyProfile = React.lazy(() => import("./Types/MyProfile"))
const PageCreateCommunitcation = React.lazy(
  () => import("./Types/PageCreateCommunitcation")
)
const PageDashboardV2 = React.lazy(() => import("./Types/PageDashboardV2"))
const PageDashboardV3 = React.lazy(() => import("./Types/PageDashboardV3"))
const PageCommunicationDetail = React.lazy(
  () => import("./Types/PageCommunicationDetail")
)
const PageMyCommunications = React.lazy(
  () => import("./Types/PageMyCommunications")
)
const PageCommunicationView = React.lazy(
  () => import("./Types/PageCommunicationView")
)
const PageMultiLayout = React.lazy(() => import("./Types/PageMultiLayout"))
const PageSearchEditCommunication = React.lazy(
  () => import("./Types/PageSearchEditCommunication")
)
const PageNotifications = React.lazy(() => import("./Types/PageNotifications"))
const PageGeneral = React.lazy(() => import("./Types/PageGeneral"))

const List = {
  create_task: PageCreateTask,
  my_tasks: PageMyTasks,
  table_dnt: PageTable,
  search_edit_tasks: PageSearchEditTask,
  dashboard: PageDashboard,
  task_detail: PageTaskDetail,
  list_task: PageListTask,
  my_profile: PageMyProfile,
  create_communication: PageCreateCommunitcation,
  dashboardv2: PageDashboardV2,
  dashboardv3: PageDashboardV3,
  communication_detail: PageCommunicationDetail,
  my_communications: PageMyCommunications,
  communication_view: PageCommunicationView,
  multi_layout: PageMultiLayout,
  search_edit_communications: PageSearchEditCommunication,
  notifications: PageNotifications,
  general: PageGeneral,
}
const MyPageOne = {
  init() {
    MyPageHelpers.addTypesFromListLazy(List)
  },
}

export default MyPageOne
